import { assessmentConstants } from '../_constants';
import { assessmentService } from '../_services';
import { alertActions } from '.';
export const assessmentActions = {

    userAssessmentUserProfile,
    assessmentLogout,

    userAssessmentLogout,
    userAssessmentOrders,

    userAssessmentSurveyLogin,

    userAssessmentSurveyLoginByOTP,


    getAssessmentPackagesList,
    getAssessmentPackagesById,
    assessmentAddToCart,
    getAssessmentCartItems,
    updateCartItemQuantity,
    getAssessmentCartPriceTotal,
    deleteCartItem,
    userAssessmentPackageBuy,
    getOrderBookList,
    userAssessmentResponseAnalytics,
    userAssessmentOrderNameUpdate,
    getAssessmentCartCount,
    saveAssessmentContactUs,
    updateAssessmentUserProfile,
    assessmentDownloadStatus,
    AssessmentUserLogout,
    getAssessmentPackagesShortList,
    getUserAssessmentLangReport

};


function assessmentLogout(props) {
    localStorage.removeItem('adminuser')
    props.history.push(`/assessment/signin`);
}

function userAssessmentLogout(props) {
    localStorage.removeItem('adminuser')
    props.history.push(`/assessment/signin`);
}



function AssessmentUserLogout(props) {
    localStorage.removeItem('adminuser')
    props.history.push(`/assessment/signin`);
}


function userAssessmentUserProfile(data) {
    return dispatch => {
        dispatch(request());
        assessmentService.userAssessmentUserProfile(data)
            .then(
                assessment => dispatch(success(assessment)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.USER_ASSESSMENT_USER_PROFILE_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.USER_ASSESSMENT_USER_PROFILE_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.USER_ASSESSMENT_USER_PROFILE_FAILURE, error } }
}







function getUserAssessmentLangReport(data) {
    return dispatch => {
        dispatch(request());
        assessmentService.getUserAssessmentLangReport(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.GET_USER_ASSESSMENT_LANG_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.GET_USER_ASSESSMENT_LANG_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.GET_USER_ASSESSMENT_LANG_FAILURE, error } }
}



function userAssessmentOrders(data) {
    return dispatch => {
        dispatch(request());
        assessmentService.userAssessmentOrders(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.USER_ASSESSMENT_PACKAGE_ORDERS_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.USER_ASSESSMENT_PACKAGE_ORDERS_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.USER_ASSESSMENT_PACKAGE_ORDERS_FAILURE, error } }
}


function userAssessmentSurveyLogin(data, props) {
    return dispatch => {
        dispatch(request());
        assessmentService.userAssessmentSurveyLogin(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                    props.history.push(`/assessment/survey`);

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_FAILURE, error } }
}


function userAssessmentSurveyLoginByOTP(data, props) {
    return dispatch => {
        dispatch(request());
        assessmentService.userAssessmentSurveyLoginByOTP(data)
            .then(
                assessment => {
                    dispatch(success(assessment));

                    console.log("assessment-------->", assessment)
                    if (assessment && assessment.userAssessmentSurveyLoginByOTPData
                        && assessment.userAssessmentSurveyLoginByOTPData.templateId === "v10"
                    ) {
                        props.history.push(`/assessment/leadership`);
                    } else {
                        props.history.push(`/assessment/survey`);
                    }


                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_FAILURE, error } }
}

function getAssessmentPackagesList(data) {
    return dispatch => {
        dispatch(request());
        assessmentService.getAssessmentPackagesList(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.GET_ASSESSMENT_PACKAGE_LIST_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.GET_ASSESSMENT_PACKAGE_LIST_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.GET_ASSESSMENT_PACKAGE_LIST_FAILURE, error } }
}

function getAssessmentPackagesById(data) {
    return dispatch => {
        dispatch(request());
        assessmentService.getAssessmentPackagesById(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.GET_ASSESSMENT_PACKAGE_BY_ID_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.GET_ASSESSMENT_PACKAGE_BY_ID_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.GET_ASSESSMENT_PACKAGE_BY_ID_FAILURE, error } }
}





function assessmentAddToCart(data, props, route) {
    return dispatch => {
        dispatch(request());
        assessmentService.assessmentAddToCart(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                    if (route === 2) {
                        dispatch(this.getAssessmentCartItems())
                    } else {
                        props.history.push(`/assessment/mycart`);
                    }
                },
                error => {

                    console.log("error---->", error)
                    if (error === "Send valid token!!!") {
                        props.history.push(`/assessment/userlogin`);
                    }
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.ASSESSMENT_ADD_TO_CART_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.ASSESSMENT_ADD_TO_CART_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.ASSESSMENT_ADD_TO_CART_FAILURE, error } }
}
function getAssessmentCartItems(data) {
    return dispatch => {
        dispatch(request());
        assessmentService.getAssessmentCartItems(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.GET_ASSESSMENT_CART_ITEMS_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.GET_ASSESSMENT_CART_ITEMS_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.GET_ASSESSMENT_CART_ITEMS_FAILURE, error } }
}


function updateCartItemQuantity(data) {
    return dispatch => {
        dispatch(request());
        assessmentService.updateCartItemQuantity(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                    dispatch(this.getAssessmentCartItems())
                    dispatch(this.getAssessmentCartPriceTotal())


                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.UPDATE_ASSESSMENT_CART_ITEMS_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.UPDATE_ASSESSMENT_CART_ITEMS_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.UPDATE_ASSESSMENT_CART_ITEMS_FAILURE, error } }
}


function getAssessmentCartPriceTotal(data) {
    return dispatch => {
        dispatch(request());
        assessmentService.getAssessmentCartPriceTotal(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.GET_ASSESSMENT_CART_PRICE_TOTAL_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.GET_ASSESSMENT_CART_PRICE_TOTAL_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.GET_ASSESSMENT_CART_PRICE_TOTAL_FAILURE, error } }
}



function deleteCartItem(data) {
    return dispatch => {
        dispatch(request());
        assessmentService.deleteCartItem(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                    dispatch(this.getAssessmentCartItems())
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.DELETE_ASSESSMENT_CART_ITEM_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.DELETE_ASSESSMENT_CART_ITEM_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.DELETE_ASSESSMENT_CART_ITEM_FAILURE, error } }
}




function userAssessmentPackageBuy(data, props) {
    return dispatch => {
        dispatch(request());
        assessmentService.userAssessmentPackageBuy(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                    if (assessment && assessment.userAssessmentPackageBuyData && assessment.userAssessmentPackageBuyData.id) {
                        props.history.push(`/assessment/ordercomplete/` + assessment.userAssessmentPackageBuyData.id);
                    }
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.USER_ASSESSMENT_PACKAGE_BUY_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.USER_ASSESSMENT_PACKAGE_BUY_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.USER_ASSESSMENT_PACKAGE_BUY_FAILURE, error } }
}



function getOrderBookList(data) {
    return dispatch => {
        dispatch(request());
        assessmentService.getOrderBookList(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.GET_ORDER_BOOK_LIST_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.GET_ORDER_BOOK_LIST_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.GET_ORDER_BOOK_LIST_FAILURE, error } }
}



function userAssessmentResponseAnalytics(data) {
    return dispatch => {
        dispatch(request());
        assessmentService.userAssessmentResponseAnalytics(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.USER_ASSESSMENT_RESPONSE_ANALYTICS_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.USER_ASSESSMENT_RESPONSE_ANALYTICS_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.USER_ASSESSMENT_RESPONSE_ANALYTICS_FAILURE, error } }
}



function userAssessmentOrderNameUpdate(data, temp) {
    return dispatch => {
        dispatch(request());
        assessmentService.userAssessmentOrderNameUpdate(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                    dispatch(this.userAssessmentOrders(temp))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.USER_ASSESSMENT_ORDER_NAME_UPDATE_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.USER_ASSESSMENT_ORDER_NAME_UPDATE_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.USER_ASSESSMENT_ORDER_NAME_UPDATE_FAILURE, error } }
}



function getAssessmentCartCount(data, temp) {
    return dispatch => {
        dispatch(request());
        assessmentService.getAssessmentCartCount(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.GET_ASSESSMENT_CART_COUNT_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.GET_ASSESSMENT_CART_COUNT_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.GET_ASSESSMENT_CART_COUNT_FAILURE, error } }
}



function saveAssessmentContactUs(data, temp) {
    return dispatch => {
        dispatch(request());
        assessmentService.saveAssessmentContactUs(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.SAVE_ASSESSMENT_CONTACT_US_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.SAVE_ASSESSMENT_CONTACT_US_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.SAVE_ASSESSMENT_CONTACT_US_FAILURE, error } }
}


function updateAssessmentUserProfile(data, temp) {
    return dispatch => {
        dispatch(request());
        assessmentService.updateAssessmentUserProfile(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                    dispatch(this.userAssessmentUserProfile())
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.UPDATE_ASSESSMENT_USER_PROFILE_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.UPDATE_ASSESSMENT_USER_PROFILE_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.UPDATE_ASSESSMENT_USER_PROFILE_FAILURE, error } }
}


function assessmentDownloadStatus(data, temp) {
    return dispatch => {
        dispatch(request());
        assessmentService.assessmentDownloadStatus(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                    dispatch(this.userAssessmentUserProfile())
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.ASSESSMENT_DOWNLOAD_STATUS_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.ASSESSMENT_DOWNLOAD_STATUS_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.ASSESSMENT_DOWNLOAD_STATUS_FAILURE, error } }
}


function getAssessmentPackagesShortList(data, temp) {
    return dispatch => {
        dispatch(request());
        assessmentService.getAssessmentPackagesShortList(data)
            .then(
                assessment => {
                    dispatch(success(assessment));
                    dispatch(this.userAssessmentUserProfile())
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: assessmentConstants.ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_REQUEST } }
    function success(assessment) { return { type: assessmentConstants.ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_SUCCESS, assessment } }
    function failure(error) { return { type: assessmentConstants.ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_FAILURE, error } }
}